import {ChangeDetectionStrategy, Component, computed, input, OnInit} from "@angular/core";
import {Fumigation, Defumigator} from "@portbase/bezoekschip-service-typescriptmodels";
import {PortvisitUtils} from "../../../../../../refdata/portvisit-utils";
import {sendQuery} from "../../../../../../common/utils";
import {Observable} from "rxjs";

@Component({
  selector: 'app-defumigator-company',
  templateUrl: './defumigator-company.component.html',
  styleUrls: ['./defumigator-company.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DefumigatorCompanyComponent implements OnInit {

  portVisitUtils = PortvisitUtils;

  fumigation = input<Fumigation>();

  defumigatorCompanies : Observable<Defumigator[]>;

  ngOnInit() {
    this.setDefumigatorCompanies();
  }

  setDefumigatorCompanies() {
    this.defumigatorCompanies = sendQuery('com.portbase.bezoekschip.common.api.dangerousgoods.GetDefumigators', {});
  }

  isOtherDefumigatorCompany = computed(() =>
    this.fumigation().defumigatorCompany?.name === 'Other'
  );
}
